import React, { useEffect, useRef, useState } from "react";
import Marquee from "react-fast-marquee";

export default function Hero() {
  const words = [
    "Blockchain & AI Solutions",
    "Crypto Exchange Development",
    "Token Development Services",
    "Smart Contracts & DeFi Systems",
    "NFT & Web3 Ecosystems",
    "Custom CRM & ERP Solutions",
  ];
  const extendedWords = [...words, words[0]];

  const [index, setIndex] = useState(0);
  const [enableTransition, setEnableTransition] = useState(true);
  const [heights, setHeights] = useState(extendedWords.map(() => 70));
  const trackRef = useRef();
  const wordRefs = useRef([]);

  useEffect(() => {
    const updateHeights = () => {
      if (wordRefs.current.every((ref) => ref !== null)) {
        setHeights(wordRefs.current.map((ref) => ref.offsetHeight));
      }
    };

    setTimeout(updateHeights, 50);

    const resizeObserver = new ResizeObserver(() => {
      updateHeights();
    });

    wordRefs.current.forEach((ref) => {
      if (ref) resizeObserver.observe(ref);
    });

    window.addEventListener("resize", updateHeights);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", updateHeights);
    };
  }, [extendedWords.length]);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (index === words.length) {
      setTimeout(() => {
        setEnableTransition(false);
        setIndex(0);
      }, 600);

      setTimeout(() => {
        setEnableTransition(true);
      }, 650);
    }
  }, [index, words.length]);

  const translateY = heights.slice(0, index).reduce((a, b) => a + b, 0);
  const currentHeight = heights[index] || 70;

  return (
    <div
      className="banner-style-two-area bg-theme text-light bg-cover overflow-hidden position-relative"
      // style={{
      //   backgroundImage: "url(assets/img/bg/we_build_intelligent_hero_section_image.jpg)",
      // }}
    >
      <video autoPlay loop muted playsInline className="bg-video desktop-video">
        <source
          src="assets/img/bg/we_build_intellingent_hero_section_video.mp4"
          type="video/mp4"
        />
      </video>

      {/* Mobile Video */}
      <video autoPlay loop muted playsInline className="bg-video mobile-video">
        <source
          src="assets/img/bg/mobile_view_hero_video.mp4"
          type="video/mp4"
        />
      </video>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-8 col-lg-10">
            <div className="banner-style-two">
              <h2
                className="split-text-left split-text-in-left split-lines mb-2"
                style={{
                  fontSize: "clamp(28px, 6vw, 56px)",
                  lineHeight: "1.2",
                }}
              >
                Leading Blockchain, Exchange &{" "}
                <br className="d-none d-md-block" />
                Token Development Company in India
              </h2>

              <div
                className="slide-container mb-4"
                style={{
                  height: `${currentHeight}px`,
                  overflow: "hidden",
                  transition: "height 0.8s cubic-bezier(0.65, 0, 0.35, 1)",
                }}
              >
                <h1 className="m-0 p-0">
                  <span
                    ref={trackRef}
                    className="slide-track d-flex flex-column"
                    style={{
                      transform: `translateY(-${translateY}px)`,
                      transition: enableTransition
                        ? "transform 0.8s cubic-bezier(0.65, 0, 0.35, 1)"
                        : "none",
                    }}
                  >
                    {extendedWords.map((word, i) => (
                      <span
                        key={i}
                        ref={(el) => (wordRefs.current[i] = el)}
                        className="word oneh1"
                        style={{
                          color: "#2f6edb",
                          fontWeight: "bold",
                          paddingBottom: "8px",
                          margin: 0,
                          whiteSpace: "normal",
                        }}
                      >
                        {word}
                      </span>
                    ))}
                  </span>
                </h1>
              </div>

              <p>
                Xeer Technology is a trusted blockchain development company in
                India delivering scalable blockchain, crypto exchange, token
                development, AI, and enterprise software solutions for startups
                and businesses worldwide.
              </p>

              <div className="d-flex flex-column flex-sm-row align-items-center gap-3 mt-4 flex-wrap">
                <a href="#" className="btn btn-style-one custom-btn">
                  Build Your Product
                </a>

                <a href="#" className="btn btn-style-two custom-btn">
                  Get Free Consultation
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
